import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from "vuex-persist/dist/umd";
import Usuarios from "./classes/Usuarios.js";

const vuexLocalStorage = new VuexPersist({
  key: 'supoapp',
  storage: window.localStorage
})

Vue.use(Vuex)

let initialState = {

}

export default new Vuex.Store({
  modules: {
    Usuarios
  },
  plugins: [vuexLocalStorage.plugin],
  mutations: {
    reset(state) {
      Object.keys(state).forEach(key => {
        Object.assign(state[key], initialState[key])
      })
    }
  },
  actions: {
    reset: ({ commit }) => {
      commit('reset');
    }
  },

})
